import React from "react";
import PropTypes from "prop-types";
import "../../styles/globals/_globals.scss";

const Button = ({ classes, text, onClick }) => {
  return (
    <button className={classes} onClick={onClick}>
      {text}
    </button>
  );
};

Button.propTypes = {
  classes: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default Button;
